import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import {
  Switch,
  FormControlLabel,
  TextField,
  Grid,
  CardActions,
  CardContent,
  CardHeader,
  Card,
  Loading,
} from "../../../components";
import { SegmentoService, notification } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import segmentoValidator from "./middlewares/segmento.validator";
import { SegmentoEntity } from "../entities";

const AddSegmento = ({ id, handleCloseDialog, buscaSegmentos }) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const [loading, setLoading] = useState(false);
  const [segmento, setSegmento] = useState({ ativado: true });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const segmentoService = new SegmentoService();

  useEffect(() => {
    if (id) {
      buscarSegmento();
    }
  }, []);

  const buscarSegmento = async () => {
    setLoading(true);
    const result = await segmentoService.getById(id);
    if (!result.isAxiosError) {
      setSegmento(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleInputChange = (event) => {
    setSegmento((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    segmentoValidator
      .validate(segmento, { abortEarly: false })
      .then(async () => {
        const segmentoEntity = new SegmentoEntity(segmento);
        if (id) {
          const response = await segmentoService.atualizar(id, segmentoEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.alteracaoSucesso();
            buscaSegmentos();
          } else {
            responseErros(response);
          }
        } else {
          const response = await segmentoService.cadastrar(segmentoEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.cadastroSucesso();
            buscaSegmentos();
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setSegmento(null);
    handleCloseDialog();
  };

  return (
    <>
      <Card className="p-3">
        <CardHeader
          title={id ? "Editar Segmento" : "Cadastrar Segmento"}
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={segmento?.ativado ? segmento?.ativado : false}
                  onChange={() =>
                    setSegmento((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={segmento?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={segmento?.descricao ? segmento.descricao : ""}
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("segmentos-cadastrar")}
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            {id ? 'Atualizar' : 'Salvar'}
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </>
  );
};

export default AddSegmento;
